import { Component, Injector, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RemoveRfidAssignmentDialogContentComponent } from '@components/dialog/remove-rfid-assignment-dialog-content/remove-rfid-assignment-dialog-content.component';
import { TableColumn } from '@models/tableColumn';
import { RfidCardsService } from '@services/entity/rfidCards.service';
import { plainToClass } from 'class-transformer';
import { AbstractEntitiesTableComponent } from '@abstracts/entities/entities-table';
import '@angular/localize/init';
import { DeleteRFIDCardForCustomerDialogContentComponent } from '../../../dialog/delete-rfid-card-for-customer-dialog-content/delete-rfid-card-for-customer-dialog-content.component';
import { RfidCardDto } from '@dto/rfidCardDto';
import { RfidScanDialogContentComponent } from '@components/dialog/rfid-scan-dialog-content/rfid-scan-dialog-content.component';
import { TableOptions } from '@models/tableOptions';

@Component({
  selector: 'app-unassigned-rfid-cards-table',
  templateUrl: './unassigned-rfid-cards-table.component.html',
  styleUrls: ['./unassigned-rfid-cards-table.component.scss'],
})
export class UnassignedRfidCardsTableComponent extends AbstractEntitiesTableComponent implements OnInit {

  public className = 'UnassignedRfidCardsTableComponent';

  public isOperatorView: boolean;
  public isSupporter: boolean = false;
  public entities: RfidCardDto[];

  public tableColumns: TableColumn[] = [
    { columnDescription: $localize`:@@UnassignedRfidCardsTablecolumn1:RFID-Kartennummer`, property: 'idTag' },
    { columnDescription: $localize`:@@UnassignedRfidCardsTablecolumn3:Zuletzt genutzt`, property: 'lastAuthorizationDate' },
    { columnDescription: $localize`:@@UnassignedRfidCardsTablecolumn2:Ladestation`, property: 'lastUsedChargingStationName' },
    { columnDescription: $localize`:@@UnassignedRfidCardsTablecolumn4:Notiz`, property: 'note' }
  ];

  public tableOptions: TableOptions = {
    showNumbering: true,
    hideActions: true,
    rowRouterLink: 'edit/{id}'
  };

  constructor(
    public rfidCardsService: RfidCardsService,
    private dialog: NgbModal,
    injector: Injector
  ) {
    super(rfidCardsService, injector);
  }

  ngOnInit(): void {
    this.isOperatorView = this.activatedRoute.snapshot.data['isOperatorView'];
    this.isSupporter = this.authenticationService.userHasRole('Supporter');
    super.ngOnInit();

    this.tableFunctions.sortColumn = 'id';
    this.tableFunctions.sortDirection = 'desc';

    this.rfidCardsService.rfidCardCreatedEvent.subscribe(rfidCard => {
      this.initializeEntities()
    });
  }

  async initializeEntities() {
    if (this.isOperatorView) {
      var customerId = this.activatedRoute.parent.snapshot.params.key;
      this.rfidCardsService.getRfidCardsOfCustomer(customerId).subscribe(result => {
        this.entities = plainToClass(RfidCardDto, result);
        this.entities = this.entities.filter(r => r.idTag != 'freecharge' && r.userId == null);
        super.setupTable();
      }, error => {});
    }
    else {
      this.rfidCardsService.getRfidCardsOfCurrentCustomer().subscribe(result => {
        this.entities = plainToClass(RfidCardDto, result);
        this.entities = this.entities.filter(r => r.idTag != 'freecharge' && r.userId == null);
        super.setupTable();
      }, error => {});
    }
  }

  matches(entity: RfidCardDto, term: string) {
    return RfidCardsService.matches(entity, term);
  }

  openRemoveAssignmentDialog(rfidCard: RfidCardDto) {
    const dialogRef = this.dialog.open(RemoveRfidAssignmentDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.rfidCard = rfidCard;

    dialogRef.result.then((result) => {
      this.initializeEntities();
    }, (backdrop) => {

    });
  }
  
  openDeleteRFIDDialog(rfidCard: RfidCardDto) {
    const dialogRef = this.dialog.open(DeleteRFIDCardForCustomerDialogContentComponent, { centered: true, backdrop: 'static' });
    dialogRef.componentInstance.rfidCard = rfidCard;

    dialogRef.result.then((result) => {
      this.initializeEntities();
    }, (backdrop) => {

    });
  }

  openScanDialog() {
    const dialogRef = this.dialog.open(RfidScanDialogContentComponent, { centered: true, backdrop: 'static', keyboard: false });
    dialogRef.componentInstance.customerId = this.activatedRoute.parent.snapshot.params.key;

    dialogRef.result.then((result) => {
      this.initializeEntities();
    }, (backdrop) => {

    });
  }
}
